import firebase from '../firebaseConfig';
import uuid from 'react-native-uuid';
import User from './User';

class Comment {
    constructor(id, text, atSeconds, timeCreated, senderId, senderName, parentCommentId) {
        this.id = id;
        this.text = text;
        this.atSeconds = atSeconds;
        this.timeCreated = timeCreated;
        this.senderId = senderId;
        this.senderName = senderName;
        this.parentCommentId = parentCommentId;
    }

    static commentsRef(track) {
        return firebase.database()
            .ref('artists').child(track.project.artist.id)
            .child('projects').child(track.project.id)
            .child('tracks').child(track.id)
            .child('revisions').child(track.currRevId)
            .child('comments');
    }

    static async getCommentsForTrack(track) {
        const snap = await Comment.commentsRef(track).once('value');
        const val = snap.val() || {};
        const entries = Object.entries(val);
        const uniqueUids = [...new Set(entries.map(([, raw]) => raw?.metadata?.uId).filter(Boolean))];
        const userByUid = {};
        await Promise.all(uniqueUids.map(async (uid) => {
            try {
                userByUid[uid] = await User.getUserName(uid);
            } catch {
                userByUid[uid] = '';
            }
        }));
        const items = entries.map(([id, raw]) => {
            const m = raw?.metadata || {};
            return new Comment(
                id,
                m.comment || '',
                m.atSeconds || 0,
                m['time created'] || 0,
                m.uId || '',
                userByUid[m.uId] || '',
                m.parentCommentId || null,
            );
        });
        return items.sort((a, b) => (a.timeCreated || 0) - (b.timeCreated || 0));
    }

    static async post(track, text, atSeconds) {
        const currUserId = firebase.auth().currentUser?.uid;
        if (!currUserId) throw new Error('Not signed in.');
        const id = uuid.v4();
        const now = Date.now();
        const metadata = {
            comment: text,
            'time created': now,
            'time modified': now,
            atSeconds: atSeconds || 0,
            parentCommentId: null,
            uId: currUserId,
            'seen by': {
                [currUserId]: {
                    'first seen': now,
                    'last seen': now,
                },
            },
        };
        await Comment.commentsRef(track).child(id).set({ metadata });
        return id;
    }
}

export default Comment;
